export default __webpack_public_path__ + "static/media/label.5b7f9cda.svg";